// Magical weights for calculating perceived relative brightness
// Taken from http://alienryderflex.com/hsp.html
export var RED_BRIGHTNESS_WEIGHT = 0.299;
export var GREEN_BRIGHTNESS_WEIGHT = 0.587;
export var BLUE_BRIGHTNESS_WEIGHT = 0.114;
export var brightness = function brightness(red, green, blue, alpha) {
  return Math.sqrt(Math.pow(red, 2) * RED_BRIGHTNESS_WEIGHT + Math.pow(green, 2) * GREEN_BRIGHTNESS_WEIGHT + Math.pow(blue, 2) * BLUE_BRIGHTNESS_WEIGHT) * alpha;
};
//# sourceMappingURL=brightness.js.map